
document.addEventListener('DOMContentLoaded', function() {

	// GESTIONE EDIZIONI DEGLI ALTRI ANNI
	let editions = this.documentElement.querySelectorAll('.edition .year');

	if (editions.length > 1) {

		editions.forEach(function(el, idx) {
			
			el.addEventListener('click', function(){

				const selected = this.closest('.edition');

				if (!selected.classList.contains('current')) {

					document.body.classList.add('--header-small');
					
					const previous = document.querySelector('.edition.current');
					
					updatePrevNext(selected);

					previous.classList.remove('current');
					selected.classList.add('current');

					gsap.to(previous.querySelector('.items-list'), {
						opacity: 0,
						height: 0,
						duration: 0.8,
						ease: "power4.inOut",
						onComplete: () => {
							//previous.classList.remove('current');
							//ScrollTrigger.refresh();

						}
					});

					gsap.to(selected.querySelector('.items-list'), {
						opacity: 1,
						height: 'auto',
						duration: 0.8,
						ease: "power4.inOut",
						onComplete: () => {
							//selected.classList.add('current');
							//ScrollTrigger.refresh();
						},
					});
				}
				
			});
		});
	}
});

function updatePrevNext(selected) {
	let found = false;

	//selected.classList.remove('next', 'prev');

	document.querySelectorAll('.edition').forEach(function (item, i) {
		item.classList.remove('next', 'prev');
		if (item === selected) {
			found = true;
			item.classList.remove('next', 'prev');
		}
		else {
			item.classList.add(found ? 'next' : 'prev');
		}
	});
}